var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FlotoLink',_vm._b({attrs:{"id":"main-content","aria-label":_vm.$t('back')}},'FlotoLink',_vm.$attrs,false),[_c('MIcon',{attrs:{"name":`long-arrow-${_vm.isRtl ? 'right' : 'left'}`}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }